<template>
  <div class="purchaseOrderClient rel flex font">
    <div class="body abs flex">
      <!-- 第一页面 -->
      <div class="firstPage">
        <div class="firstPageBody flex aic jc-sb">
          <div class="bigTable">
            <div class="topBox">
              <div class="flex aic jc-sb">
                <div class="flex aic">
                  <span style="height: 34px;width: 34px;background-color: #CE86F0;border-radius: 4px;"
                    class="flex aic jc-c">
                    <i class="iconfont icon-a-PurchaserOrders2_huaban1 f22 fff"></i>
                  </span>
                  <div class="flex fdc ml-10 rel">
                    <span class="f12 f333">{{ $t('Order.OrderPurchaseOrder') }}</span>
                    <div class="flex aic fwb f18 f333">
                      <p class="ovhidden1">
                        {{ store.lang == 'zh-cn' ?
                          `${searchOrderObj.userInfoName}${$t('Order.PurchaseOrders')}` :
                          `${searchOrderObj.userInfoName} ${$t('Order.PurchaseOrders')}` }}
                      </p>
                    </div>
                    <!-- <Dropdown :data="teamList" :id="searchOrderObj.userInfoID" :prop="{ id: 'id', value: 'name' }"
                      @click-row="getTeamUserID" @input="getTeamList1" @scroll="getTeamList2">
                      <div class="flex aic fwb f18 f333">
                        <span class="ovhidden1" style="max-width:calc(100% - 13px);width:auto;height:20px">
                          {{ store.lang == 'zh-cn' ?
                            `${searchOrderObj.userInfoName}${$t('Order.PurchaseOrders')}` :
                            `${searchOrderObj.userInfoName} ${$t('Order.PurchaseOrders')}` }}
                        </span>
                        <i class="iconfont icon-xiangyou ml-5 mt-5" style="font-size: 10px;transform: scale(0.8);"></i>
                      </div>
                    </Dropdown> -->
                  </div>
                </div>
              </div>
              <div class="flex aic jc-sb" style="margin-top: 9px;">
                <div class="flex aic w100p">
                  <el-select v-model="searchOrderObj.Sources"
                    @change="getPurOrderList(1, '', searchOrderObj.userInfoID)"
                    @focus="pubData.getOrderFromList('purchaseorder')" v-Loadmore="pubData.getOrderFromList1"
                    :filter-method="pubData.remoteOrderFromList" :loading="selectLoading" clearable filterable
                    :placeholder="$t('Order.SelectTheSources')" class="mr-10" style="width:15%;">
                    <el-option v-for="item in orderFromList" :key="item.website_id" :label="item.website_title"
                      :value="item.website_id" />
                  </el-select>
                  <el-select v-model="searchOrderObj.Vendor" clearable @focus="getSuppier"
                    :placeholder="$t('Order.orderSelectTheVendor')" class="mr-10"
                    @change="getPurOrderList(1, '', searchOrderObj.userInfoID)" style="width:15%;">
                    <el-option v-for="item in supplierList" :key="item.value" :label="item.label" :value="item.value" />
                  </el-select>
                  <el-select v-model="searchOrderObj.PorderType"
                    @change="getPurOrderList(1, '', searchOrderObj.userInfoID)" clearable
                    :placeholder="$t('Order.orderSelectType')" class="mr-10" style="width:15%">
                    <el-option v-for="item in orderTypeList" :key="item.id" :value="item.id" :label="item.name" />
                  </el-select>
                  <el-select v-model="searchOrderObj.Status" @change="getPurOrderList(1, '', searchOrderObj.userInfoID)"
                    clearable :placeholder="$t('Order.orderSelectStatus')" class="mr-10" style="width:15%">
                    <el-option v-for="item in stateList" :key="item.value" :value="item.value" :label="item.label" />
                  </el-select>
                  <el-select v-model="searchOrderObj.Model" @change="getPurOrderList(1, '', searchOrderObj.userInfoID)"
                    @focus="pubData.getModel" v-Loadmore="pubData.getModel1" :filter-method="pubData.remoteModel"
                    :loading="selectLoading" filterable clearable :placeholder="$t('Order.orderSelectModel')"
                    class="mr-10" style="width:15%">
                    <el-option v-for="item in modelList" :key="item.value" :value="item.value" :label="item.label" />
                  </el-select>
                  <!-- <div class="mr-10" style="width:15%">
                    <el-date-picker v-model="searchOrderObj.Date"
                      @change="getPurOrderList(1, '', searchOrderObj.userInfoID)" clearable type="daterange"
                      :format="store.lang == 'en-us' ? 'DD-MM-YYYY' : 'YYYY-MM-DD'" value-format="YYYY-MM-DD"
                      unlink-panels :range-separator="$t('Order.orderDateTo')"
                      :start-placeholder="$t('Order.orderStartDate')" :end-placeholder="$t('Order.orderEndDate')"
                      :shortcuts="shortcuts" size="size" style="width:100%" />
                  </div> -->
                  <el-input v-model="keyword" @input="searchPurorder" clearable :placeholder="$t('Order.orderKeyWords')"
                    :prefix-icon="Search" style="width:25%" />
                </div>
                <!-- <div class="flex aic ml-30">
                  <el-button @click="clearSearchMethod" plain
                    style="height: 30px;width: 30px;border: 1px solid #CAD2D9;">
                    <i class="iconfont icon-qingkongbiao fwb"></i>
                  </el-button>
                  <el-button @click="getPurOrderList(1, '', searchOrderObj.userInfoID)" plain
                    style="height: 30px;width: 30px;border: 1px solid #CAD2D9;">
                    <i class="iconfont icon-shuaxin fwb"
                      :style="getPurOrderObj.loading ? 'animation: loading-rotate 1s linear infinite;' : ''"></i>
                  </el-button>
                </div> -->
              </div>
            </div>
            <!-- 表格 -->
            <div class="bodeytable pl-15 mt-15">
              <el-table ref="purOrderTableRef" :data="getPurOrderObj.PurOrderList" @row-dblclick="getPurOrderID"
                @current-change="handleCurrentChange" @selection-change="handleSelectionChange"
                v-loading="getPurOrderObj.loading" :cell-style="setCellStyle" border stripe
                v-el-table-infinite-scroll="getPurOrderList1" height="100%" style="width: 100%;" :header-cell-style="{
                  'background-color': '#F2F4F7',
                  'font-weight': 'bold', 'height': '40px', 'fontSize': '14px'
                }">
                <template #empty>
                  <Empty :iconSize="150" :fontSize="20" />
                </template>
                <el-table-column label="ID">
                  <template #default="{ row, $index }">
                    <div class="flex aic" :class="{ 'fwb': row.is_read == 0 }" style="width: 100%;">
                      <el-tooltip :disabled="isShowTooltip" class="box-item" effect="dark" :content="row.order_number"
                        placement="top">
                        <span @mouseenter="getWidth($event)" @click="getPurOrderID(row)" class="orderIDbox"
                          :class="{ 'orderIDbox1': row.from_supplier == 0 }">
                          {{ row.order_number }}
                        </span>
                      </el-tooltip>
                      <span v-show="row.from_supplier != 0" class="fromName flex aic jc-c ml-10 f12">
                        From {{ row.supplier_nickname }}
                      </span>
                    </div>
                  </template>
                </el-table-column>
                <el-table-column show-overflow-tooltip>
                  <template #header>
                    <span class="ovhidden1 flex mt-5 f333"> {{ $t('Order.OrderSubject') }} </span>
                  </template>
                  <template #default="{ row, $index }">
                    <span :class="{ 'fwb': row.is_read == 0 }">{{ row.subject ? row.subject : '-' }}
                    </span>
                  </template>
                </el-table-column>
                <el-table-column show-overflow-tooltip>
                  <template #header>
                    <span class="ovhidden1 flex mt-5 f333"> {{ $t('Order.OrderTableType') }}</span>
                  </template>
                  <template #default="{ row, $index }">
                    <span :class="{ 'fwb': row.is_read == 0 }">{{ row.type_text ? row.type_text : '-' }}
                    </span>
                  </template>
                </el-table-column>
                <el-table-column show-overflow-tooltip>
                  <template #header>
                    <span class="ovhidden1 flex mt-5 f333">{{ $t('Order.OrderVendor') }} </span>
                  </template>
                  <template #default="{ row, $index }">
                    <span :class="{ 'fwb': row.is_read == 0 }">
                      {{ row.supplier ? row.supplier : '-' }}
                    </span>
                  </template>
                </el-table-column>
                <el-table-column show-overflow-tooltip>
                  <template #header>
                    <span class="ovhidden1 flex mt-5 f333">{{ $t('Order.OrderContact') }}</span>
                  </template>
                  <template #default="{ row, $index }">
                    <span :class="{ 'fwb': row.is_read == 0 }">
                      {{ row.buyer ?
                        `${Kernaldec(row.buyer.firstname)} ${Kernaldec(row.buyer.lastname)}` : '-' }}
                    </span>
                  </template>
                </el-table-column>
                <el-table-column show-overflow-tooltip>
                  <template #header>
                    <span class="ovhidden1 f333">{{ $t('Order.Source') }}</span>
                  </template>
                  <template #default="{ row, $index }">
                    <span :class="{ 'fwb': row.is_read == 0 }">
                      {{ row.website_title ? row.website_title : '-' }}</span>
                  </template>
                </el-table-column>
                <el-table-column>
                  <template #header>
                    <span class="ovhidden1 flex mt-5 f333">{{ $t('Order.OrderTableItems') }}</span>
                  </template>
                  <template #default="{ row, $index }">
                    <span :class="{ 'fwb': row.is_read == 0 }">{{ row.itmes ? row.itmes : '-' }}
                    </span>
                  </template>
                </el-table-column>
                <el-table-column>
                  <template #header>
                    <span class="ovhidden1 flex mt-5 f333"> {{ $t('Order.OrderTableStatus') }} </span>
                  </template>
                  <template #default="{ row, $index }">
                    <div class="flex aic">
                      <div class="iconBox flex aic jc-c">
                        <Circularprogressbar :State="row.status"></Circularprogressbar>
                      </div>
                      <el-tooltip :disabled="isShowTooltip" class="box-item" effect="dark" :content="row.status_text"
                        placement="top">
                        <span @mouseenter="getWidth($event)" class="ml-5 stateBox" :class="{ 'fwb': row.is_read == 0 }">
                          {{ row.status_text }}
                        </span>
                      </el-tooltip>
                    </div>
                  </template>
                </el-table-column>
                <el-table-column show-overflow-tooltip>
                  <template #header>
                    <span class="ovhidden1 flex mt-5 f333"> {{ $t('Order.OrderTableCreatedDate') }}
                    </span>
                  </template>
                  <template #default="{ row, $index }">
                    <span :class="{ 'fwb': row.is_read == 0 }">
                      {{ row.create_time }}
                    </span>
                  </template>
                </el-table-column>
              </el-table>
            </div>
            <div class="botoomHeight flex jc-end mt-15 mb-15">
              <el-pagination v-model:current-page="currentPage" :total="pageTotal" v-model:page-size="pageSize"
                pager-count="5" :page-sizes="[20, 30, 40, 50, 100]" @current-change="changeCurrPage"
                @size-change="changeSize" layout="total, sizes, prev, pager, next, jumper" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import * as utils from '../utils'
import { useRouter } from "vue-router"
import { HomeStore } from "@/slack/index.js";
import Empty from "./Empty.vue";
import i18n from "@/assets/lang";
import useClipboard from 'vue-clipboard3'
import * as pubData from "./orderData.js";
import NoData from "./NoData.vue";
import { Search } from '@element-plus/icons-vue'
import { useDemoStore } from "@/pinia/index";
import { Kernaldec } from "@/hooks/useDecrypt";
import Dropdown from "@/components/Dropdown/Dropdown.vue";
import Circularprogressbar from "./Circularprogressbar.vue";
import * as api from "@/api/apiPayOrder/index";
import { ElMessage, ElMessageBox } from 'element-plus'
import { ref, reactive, onMounted, onUnmounted, nextTick, computed, defineAsyncComponent } from "vue"
const router = useRouter()
const routerID = router.currentRoute.value.query.fromPorderID
const routerName = router.currentRoute.value.query.fromPorderName
const store = useDemoStore()
// 权限对象
const LimitObj = store.powerList.Order.PurchaseOrder.handle_auth
// 切换状态变量
const isTransaction = (val, info) => {
  store.changeOrderShow(val)
}
// 新建订单
const createNewPorderRef = ref()
const createPorder = () => {
  createNewPorderRef.value.newOrderState = true
}
// 新增后滚动到顶部
const matchCurrentRow = (val) => {
  leftBox.value.scrollTop = 0
}
/************ 获取采购订单开始 ************/
let purOrderTableRef = ref("");
const handleCurrentChange = (e) => {
  if (e) {
    HomeStore().selectData = e;
    purOrderTableRef.value.toggleRowSelection(e, true);
  }
};
const handleSelectionChange = (e) => {
  if (e.length > 0) {
    purOrderTableRef.value.setCurrentRow(e[e.length - 1]);
    e.map((item, index) => {
      if (index == e.length - 1) {
        purOrderTableRef.value.toggleRowSelection(item, true);
      } else {
        purOrderTableRef.value.toggleRowSelection(item, false);
      }
    });
  } else {
    purOrderTableRef.value.setCurrentRow("");
    HomeStore().selectData = "";
  }
};
// 获取团队数据
const teamList = ref([])
const teamData = { token: store.token, group: 2, name: '', source: 'purchaseorder', page: 1, pageSize: 30 }
const getTeamList = () => {
  api.ordersConfigGetTeam(teamData).then(res => {
    let array = res.data?.data
    teamLastPage.value = res.data?.last_page
    array?.splice(array?.findIndex(item => String(item.id) == String(store.user_uid)), 1) //把团队数据里自己的id删除
    teamList.value = [...[{ id: '', name: i18n.global.t('Order.OrderAll') },
    { id: String(store.user_uid), name: i18n.global.t('Order.OrderMy') }], ...array]
  })
}
const getTeamList1 = (val) => {
  teamData.name = val
  api.ordersConfigGetTeam(teamData).then(res => {
    teamLastPage.value = res.data?.last_page
    if (val) {
      teamList.value = res.data?.data
    } else {
      let array = res.data?.data
      let array1 = [{ id: '', name: i18n.global.t('Order.OrderAll') },
      { id: String(store.user_uid), name: i18n.global.t('Order.OrderMy') }]
      array?.splice(array?.findIndex(item => String(item.id) == String(store.user_uid)), 1) //把团队数据里自己的id删除
      teamList.value = [...array1, ...array]
    }
  })
}
const teamLastPage = ref(0)
const getTeamList2 = () => {
  if (teamLastPage.value == teamData.page) return false
  teamData.page++
  api.ordersConfigGetTeam(teamData).then(res => {
    let array = res.data?.data
    teamLastPage.value = res.data?.last_page
    array?.splice(array?.findIndex(item => String(item.id) == String(store.user_uid)), 1) //把团队数据里自己的id删除
    teamList.value = [...teamList.value, ...array]
  })
}
const getTeamUserID = (val) => {
  getPurOrderList(1, 'Team', val.id, val.name)
}
// 状态列表
const stateList = computed(() => {
  return [{ label: i18n.global.t('Order.OrderCreated'), value: 1 },
  { label: i18n.global.t('Order.OrderApprove'), value: 2 },
  { label: i18n.global.t('Order.OrderTraded'), value: 3 },
  { label: i18n.global.t('Order.OrderStateCancel'), value: 4 }]
})

// 类型列表
const orderTypeList = computed(() => {
  return [{ id: 1, name: i18n.global.t('Order.sOrderTypeRetail') },
  { id: 2, name: i18n.global.t('Order.sOrderTypeWholesale') }]
})

// 搜索变量
const searchOrderObj = reactive({
  Sources: '', Contact: '', Vendor: '', PorderType: '', Status: '', Model: '', Date: null,
  purchaseorder_id: '', orderDate: [], userInfoID: String(store.user_uid), userInfoName: '', PiName: ''
})
const keyword = ref('')

//采购单列表
const getPurOrderObj = reactive({ PurOrderList: [], loading: false })

const screenData = {
  token: store.token, page: '', type: '', pageSize: '', owner_id: '', website_id: '',
  buyer_id: '', customer_info_id: '', status: '', supplier_id: '', keyword: '', product_id: '',
  start_time: { year: '', month: '', day: '' }, end_time: { year: '', month: '', day: '' },
}
const getPurOrderList = (page, info, ownerID, ownerName) => {
  pOrderInfo.pOrderID = ''
  getPurOrderObj.loading = true
  if (info == 'router') { //路由参数获取全部数据
    keyword.value = routerName
    screenData.purchaseorder_id = routerID
    searchOrderObj.userInfoID = ''
    searchOrderObj.userInfoName = i18n.global.t('Order.OrderAll')
    screenData.owner_id = ''
    screenData.keyword = ''
  } else if (info == 'New') { //新增刷新 获取当前选取的责任人数据
    searchOrderObj.userInfoID = ownerID
    searchOrderObj.userInfoName = ownerName
    screenData.purchaseorder_id = ''
    screenData.keyword = keyword.value
    screenData.owner_id = searchOrderObj.userInfoID
  } else if (info == 'Team') { //切换团队数据
    searchOrderObj.userInfoID = ownerID
    searchOrderObj.userInfoName = ownerName
    screenData.purchaseorder_id = ''
    screenData.keyword = keyword.value
    screenData.owner_id = searchOrderObj.userInfoID
  } else {//默认获取个人的数据
    let array = teamList.value?.filter(item => item.id == ownerID)
    searchOrderObj.userInfoID = ownerID ? ownerID : searchOrderObj.userInfoID
    searchOrderObj.userInfoName = array[0]?.name ? array[0]?.name : i18n.global.t('Order.OrderMy')
    screenData.purchaseorder_id = ''
    screenData.keyword = keyword.value
    screenData.owner_id = searchOrderObj.userInfoID
  }
  screenData.page = page
  screenData.pageSize = pageSize.value
  screenData.type = searchOrderObj.PorderType
  screenData.website_id = searchOrderObj.Sources
  screenData.customer_info_id = searchOrderObj.Contact
  screenData.supplier_id = searchOrderObj.Vendor
  screenData.status = searchOrderObj.Status
  screenData.product_id = searchOrderObj.Model
  screenData.start_time.year = searchOrderObj.Date ? searchOrderObj.Date[0].split('-')[0] : ''
  screenData.start_time.month = searchOrderObj.Date ? searchOrderObj.Date[0].split('-')[1] : ''
  screenData.start_time.day = searchOrderObj.Date ? searchOrderObj.Date[0].split('-')[2] : ''
  screenData.end_time.year = searchOrderObj.Date ? searchOrderObj.Date[1].split('-')[0] : ''
  screenData.end_time.month = searchOrderObj.Date ? searchOrderObj.Date[1].split('-')[1] : ''
  screenData.end_time.day = searchOrderObj.Date ? searchOrderObj.Date[1].split('-')[2] : ''
  api.cpoList(screenData).then((res) => {
    getPurOrderObj.loading = false
    lastPage.value = res.data?.last_page
    currentPage.value = res.data?.current_page
    getPurOrderObj.PurOrderList = res.data?.data
    pageTotal.value = res.data.total ? res.data.total : 0
    if (info == 'router' || info == 'New') {
      store.changeOrderShow(true)
      pOrderInfo.orderID = getPurOrderObj?.PurOrderList[0]?.order_id ? getPurOrderObj?.PurOrderList[0]?.order_id : pOrderInfo.orderID//三目运算防止新增owner为其他人时拿不到数据导致切换校验触发
      pOrderInfo.isOrderState = getPurOrderObj?.PurOrderList[0]?.from_supplier ? getPurOrderObj?.PurOrderList[0]?.from_supplier : pOrderInfo.isOrderState
      pOrderInfo.pOrderID = getPurOrderObj?.PurOrderList[0]?.customer_order_id ? getPurOrderObj?.PurOrderList[0]?.customer_order_id : pOrderInfo.pOrderID
      let isReading = getPurOrderObj?.PurOrderList[0]?.is_read ? getPurOrderObj?.PurOrderList[0]?.is_read : 1
      // ReadOrderMthods(pOrderInfo.pOrderID, isReading)
    }
  })
}
const getPurOrderList1 = () => {
  if (getPurOrderObj.PurOrderList.length == 0 || screenData.page == lastPage.value) return false
  screenData.page++
  api.cpoList(screenData).then((res) => {
    getPurOrderObj.PurOrderList = [...getPurOrderObj.PurOrderList, ...res.data && res.data.data]
    lastPage.value = res.data?.last_page
    currentPage.value = res.data?.current_page
  })
}
//分页
const pageSize = ref(50)
const currentPage = ref(1)
const pageTotal = ref(0)
const lastPage = ref('')
const changeCurrPage = (val) => {
  getPurOrderList(val, '', searchOrderObj.userInfoID)
}
const changeSize = (val) => {
  getPurOrderList(1, '', searchOrderObj.userInfoID)
}

// 模糊搜索
const searchPurorder = () => {
  utils.debounce(500, () => {
    getPurOrderList(1, '', searchOrderObj.userInfoID)
  })
}
// 清除筛选条件
const clearSearchMethod = () => {
  searchOrderObj.Sources = ''
  searchOrderObj.Contact = ''
  searchOrderObj.Vendor = ''
  searchOrderObj.PorderType = ''
  searchOrderObj.Status = ''
  searchOrderObj.Model = ''
  searchOrderObj.Date = null
  searchOrderObj.PorderType = ''
  getPurOrderList(1, '', searchOrderObj.userInfoID)
}
// 精确搜索
const searchState = ref(false)
const searchOpen = () => { searchState.value = true }
const searchWinMethod = () => {
  getPurOrderList(1, '', searchOrderObj.userInfoID)
  searchState.value = false
}
const resetSearchWin = () => {
  searchOrderObj.Sources = ''
  searchOrderObj.Contact = ''
  searchOrderObj.Vendor = ''
  searchOrderObj.PiName = ''
  searchOrderObj.PorderType = ''
  searchOrderObj.Status = ''
  searchOrderObj.Model = ''
  searchOrderObj.Date = null
  searchOrderObj.PorderType = ''
}
// 列表复制单号
const { toClipboard } = useClipboard(); //剪切板
const copyInfo = ref('')
const copyText = (info) => {
  copyInfo.value = info
  try {
    toClipboard(copyInfo.value)
    ElMessage({ message: i18n.global.t('Order.orderReplication'), type: 'success' })
  } catch (e) {
    console.error(e)
  }
}
/************ 获取采购订单结束 ************/
/************ 获取采购订单详情开始 ************/
const leftBox = ref()
const leftBoxItem = ref()
const CustomerPorderDetailRef = ref()
const pOrderInfo = reactive({ pOrderID: '', orderID: '', isOrderState: '' })
const getPurOrderID = (val, info) => {
  // if (pOrderInfo.pOrderID == val.customer_order_id) return false
  let isToggle = CustomerPorderDetailRef.value ? CustomerPorderDetailRef.value?.isChooseMethod() : true
  if (!isToggle) {
    ElMessageBox.confirm(
      i18n.global.t('Order.orderEditInformation'),
      i18n.global.t('Order.orderTips'),
      {
        confirmButtonText: i18n.global.t('Order.orderConfirm'),
        cancelButtonText: i18n.global.t('Order.orderCancel'),
        type: 'warning',
      }
    ).then(() => {
      pOrderInfo.orderID = val.order_id
      pOrderInfo.isOrderState = val.from_supplier
      // pOrderInfo.isOrderState = 1
      pOrderInfo.pOrderID = val.customer_order_id
      let isReading = val.is_read
      ReadOrderMthods(pOrderInfo.pOrderID, isReading)
    }).catch(() => {
      console.log('不关闭')
    })
  } else {
    pOrderInfo.orderID = val.order_id
    pOrderInfo.isOrderState = val.from_supplier
    // pOrderInfo.isOrderState = 1
    pOrderInfo.pOrderID = val.customer_order_id
    let isReading = val.is_read
    ReadOrderMthods(pOrderInfo.pOrderID, isReading)
  }
  if (!store.orderShow) {
    leftBoxItem.value?.forEach(item => {
      nextTick(() => {
        if (item.className == 'list flex aic success-row') {
          leftBox.value.scrollTo({ top: item.offsetTop - 148, behavior: "smooth" })
        }
      })
    })
    store.changeOrderShow(true)
  }
}

// 订单已读标记
const ReadOrderMthods = (customerOrderID, isReading) => {
  if (isReading == 1) return false
  api.cpoRead({ token: store.token, customer_order_id: customerOrderID }).then(res => {
    if (res.Status == 0) {
      getPurOrderObj.PurOrderList?.forEach(item => {
        if (item.customer_order_id == customerOrderID) {
          item.is_read = 1
        }
      })
    }
  })
}
const setCellStyle = ({ row }) => {//默认高亮和点击高亮
  if (pOrderInfo.pOrderID == row.customer_order_id) {
    return { backgroundColor: '#E6F0FF !important' }
  }
}
/************ 获取采购订单详情结束 ************/

/************ 操作相关方法开始 ************/
const purOrderDel = () => {// 删除采购单
  const index = getPurOrderObj.PurOrderList.findIndex(item => item.customer_order_id == pOrderInfo.pOrderID)
  getPurOrderObj.PurOrderList.splice(index, 1)
  const isIndex = getPurOrderObj.PurOrderList?.length - 1
  if (getPurOrderObj.PurOrderList?.length) {
    if (index > isIndex) {
      pOrderInfo.pOrderID = getPurOrderObj.PurOrderList[index - 1].customer_order_id
      pOrderInfo.orderID = getPurOrderObj?.PurOrderList[index - 1]?.ordder_id
      pOrderInfo.isOrderState = getPurOrderObj?.PurOrderList[index - 1]?.from_supplier
    } else {
      pOrderInfo.pOrderID = getPurOrderObj.PurOrderList[index].customer_order_id
      pOrderInfo.orderID = getPurOrderObj?.PurOrderList[index]?.ordder_id
      pOrderInfo.isOrderState = getPurOrderObj?.PurOrderList[index]?.from_supplier
    }
  } else {
    pOrderInfo.pOrderID = ''
    pOrderInfo.orderID = ''
    pOrderInfo.isOrderState = ''
  }
  pageTotal.value = pageTotal.value - 1
}
const delOrderListItem = (total) => {
  if (total == 0) {
    const index = getPurOrderObj.PurOrderList.findIndex(item => item.customer_order_id == pOrderInfo.pOrderID)
    getPurOrderObj.PurOrderList.splice(index, 1)
    const isIndex = getPurOrderObj.PurOrderList?.length - 1
    if (getPurOrderObj.PurOrderList?.length) {
      if (index > isIndex) {
        pOrderInfo.pOrderID = getPurOrderObj.PurOrderList[index - 1].customer_order_id
        pOrderInfo.orderID = getPurOrderObj?.PurOrderList[index - 1]?.ordder_id
        pOrderInfo.isOrderState = getPurOrderObj?.PurOrderList[index - 1]?.from_supplier
      } else {
        pOrderInfo.pOrderID = getPurOrderObj.PurOrderList[index].customer_order_id
        pOrderInfo.orderID = getPurOrderObj?.PurOrderList[index]?.ordder_id
        pOrderInfo.isOrderState = getPurOrderObj?.PurOrderList[index]?.from_supplier
      }
    } else {
      pOrderInfo.pOrderID = ''
      pOrderInfo.orderID = ''
      pOrderInfo.isOrderState = ''
    }
  } else {
    getPurOrderObj.PurOrderList.forEach(item => {
      if (item.customer_order_id == pOrderInfo.pOrderID) {
        item.itmes = total
      }
    })
  }
}
//  编辑后修改前端订单数量
const editOrderDetail = (val, val2, subject, state) => {
  getPurOrderObj.PurOrderList?.forEach(item => {
    if (item.customer_order_id == pOrderInfo.pOrderID) {
      item.type = val2 ? val2 : item.type
      item.itmes = val ? val : item.itmes
      // item.qty_total = val ? val : item.itmes
      if (val2) {
        item.type_text = val2 == 2 ? i18n.global.t('Order.sOrderTypeWholesale') : i18n.global.t('Order.sOrderTypeRetail')
      } else {
        item.type_text = item.type_text
      }
      item.subject = subject ? subject : item.subject
      item.status = state ? state : item.status
      item.status_text = state ? stateList.value?.filter(item => item.value == state)[0].label : item.status_text
    }
  })
}
// 编辑状态后前端修改状态
const editOrderState = (state) => {
  getPurOrderObj.PurOrderList.forEach(item => {
    if (item.customer_order_id == pOrderInfo.pOrderID) {
      item.status = state
      item.status_text = stateList.value.filter(item => item.value == state)[0].label
    }
  })
}
/************ 操作相关方法结束 ************/

/************ 获取供应商开始 ************/
const supplierList = ref([])
const getSuppier = () => {
  api.cpoGetVendor({ token: store.token }).then((res) => {
    supplierList.value = res.data?.map((item) => {
      item.label = item.CompanyName
      item.value = item.company_id
      return item
    })
  })
}
/************ 获取供应商结束 ************/

/************ 搜索获取产品列表开始 ************/
const modelList = ref(pubData.modelList)
const shortcuts = ref(pubData.shortcuts)
const orderFromList = ref(pubData.orderFromList)
const selectLoading = ref(pubData.selectLoading)
/************ 搜索获取产品列表结束 ************/

//视口
// const windowWidth = ref(window.innerWidth)
// const handleResize = () => {
//   windowWidth.value = window.innerWidth
// }

const isShowTooltip = ref(true)
const getWidth = (event) => {
  if (event.target.scrollWidth > event.target.clientWidth) {
    isShowTooltip.value = false
  } else {
    isShowTooltip.value = true
  }
}

onMounted(() => {
  getTeamList()
  if (routerID) {
    getPurOrderList(1, 'router', searchOrderObj.userInfoID)
  } else {
    getPurOrderList(1, '', searchOrderObj.userInfoID)
  }
  // window.addEventListener('resize', handleResize)
})

onUnmounted(() => {
  // window.removeEventListener('resize', handleResize)
})
</script>

<style lang="less" scoped>
@import "./less/pubTableCss.less";
@import './less/purchaseOrderClient.less';
</style>